export default "__VITE_ASSET__YvZ9IfsG__"